import { useLocation, useNavigate } from "react-router-dom";
import "./login.component.scss";
import { Button } from "@mui/material";
import { getUTMParams } from "../../services/handle-route.service";
import AuthenMysa from "../../services/authen/mysa.authen";
import COVER_IMG from "../../assets/images/login-cover-img.png";
import LOGIN_PRODUCT_IMG from "../../assets/images/login-product-img.png";
import AI_PURPLE from "../../assets/images/ai-icon-purple.png"
const LoginComponent = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { utmSource, utmMedium, version, feature, redirect } = getUTMParams(location);
    const loginButton = () => {
        AuthenMysa().authenticateUrl(utmSource || "", utmMedium || "", feature || "");
    }
    const registerButton = () => {
        AuthenMysa().authenticateUrlRegister(utmSource || "", utmMedium || "", feature || "");
    }

    const homeLogo = () => {
        navigate("/login")
    }

    return (
        <>
            <div className="login-control">
                <div className="login-cover-control">
                    <img src={COVER_IMG} className="login-cover-img"></img>
                </div>

                <div className="border-std login-main-control">
                    <div className="login-item-control">
                        <img src={AI_PURPLE} className="icon-ai"></img>
                        <span className="login-sub-text-tile">Welcome To</span>
                        <img src={LOGIN_PRODUCT_IMG} className="login-product-img"></img>
                        <div className="buton-control">
                            <Button className="button-std login-button" onClick={loginButton}>Login</Button>
                          
                        </div>
                        <span className="signup-text" onClick={registerButton}>ยังไม่มีบัญชี? <span className="signup-link">No Account?, Register</span></span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LoginComponent;